export default function Correspondances() {
  return <div>Correspondances en développement...</div>
}